import { NavLink, Outlet, Link } from "react-router-dom";
import { platformClient, signOutPlatform } from "../../platformClient.js";
import { useMfaRequiredRoute } from "../security/useMfaRequiredRoute.js";

function navClass({ isActive }: { isActive: boolean }): string {
  return isActive ? "platform-nav-link platform-nav-link--active" : "platform-nav-link";
}

/** Platform console chrome — separate from marketing nav and owner dashboard. */
export function PlatformShell() {
  useMfaRequiredRoute(platformClient, "/platform/security");
  return (
    <div className="platform-console">
      <header className="platform-console-header">
        <Link to="/" className="platform-console-logo" aria-label="Lumora home">
          <img
            className="platform-console-mark"
            src="/brand/lumora-mark.png"
            alt=""
            width={28}
            height={28}
            decoding="async"
          />
          <span>Lumora</span>
        </Link>
        <nav className="platform-console-nav" aria-label="Platform console">
          <NavLink to="/platform/ops" className={navClass}>
            Live ops
          </NavLink>
          <NavLink to="/platform/activity" className={navClass}>
            Activity
          </NavLink>
          <NavLink to="/platform/approvals" className={navClass}>
            Approvals
          </NavLink>
          <NavLink to="/platform/payments" className={navClass}>
            Payments
          </NavLink>
          <NavLink to="/platform/billing" className={navClass}>
            Billing
          </NavLink>
          <NavLink to="/platform/sites"className={navClass}>
            Sites
          </NavLink>
          <NavLink to="/platform/settings" className={navClass}>
            Settings
          </NavLink>
        </nav>
        <button
          type="button"
          className="platform-console-signout"
          onClick={() => {
            signOutPlatform();
            window.location.hash = "#/platform/signin";
            window.location.reload();
          }}
        >
          Sign out
        </button>
      </header>
      <div className="platform-console-body">
        <Outlet />
      </div>
    </div>
  );
}
